import {A360ProductCd} from 'Quoting/models/Quoting';

export const getPolicySummaryPropertyPaths = (productCd: A360ProductCd | undefined) => ({
  policyCreateDate: 'transactionDetails.txCreateDate',
  policyEffectiveDate: 'termDetails.termEffectiveDate',
  isSelfBill: 'isSelfBill',
  originalRateRequestDate: 'originalRateRequestDate',
  rateRequestDate: 'rateRequestDate',
  isPriorCoverage: 'isPriorCoverage',
  priorCarrierName: 'priorCarrierDetails.carrierName',
  priorCoverageNo: 'priorCarrierDetails.carrierPolicyNo',
  deliveryModelCd: 'deliveryModelCd',
  riskStateCd: 'riskStateCd',
  numberOfEligibleLives: 'participationDetails.numberOfEligibleLives',
  sicCode: 'sicCode',
  sicDescription: 'sicDescription',
  uwOffer: productCd === A360ProductCd.HI ? 'policyDetail.brokerUWOffer' : 'policyDetail.quoteUWOffer',
  isPowerBroker: 'policyDetail.powerBroker',
  modelName: '_modelName',
});
